import PropTypes from 'prop-types'

const BordePrincipal = (props) => {
  return (
    <fieldset className={`fieldset ${props.className || ''}`}>
      <legend>{props.titulo}</legend>
      <div>{props.children}</div>
    </fieldset>
  )
}

BordePrincipal.propTypes = {
  titulo: PropTypes.string.isRequired,
  className: PropTypes.string,
  children: PropTypes.node
}

export default BordePrincipal
